import { Bleed, Box, Text } from 'braid-design-system';
import { useState, type ReactNode } from 'react';
import { InlineCode } from 'scoobie';

// Inspired by HighlightBox https://github.com/SEEK-Jobs/indie-demi/blob/e6982c1c0ec375b7ae2fa4790ed71bc29d925409/src/pages/use-cases/job-posting/ad-selection/v2/AdSelectionPanel.tsx#L342
export const AnnotationContainer = ({ children }: { children: ReactNode }) => {
  const [highlighted, setHighlighted] = useState(false);
  // TODO: consider setting up context for Annotation to react to hover events

  return (
    <Bleed horizontal="small" vertical="small">
      <Box
        background={highlighted ? 'formAccentSoft' : undefined}
        boxShadow={highlighted ? 'borderFormAccent' : undefined}
        paddingX="small"
        paddingY="small"
        position="relative"
        onMouseEnter={(event) => {
          event.stopPropagation();
          setHighlighted(true);
        }}
        onMouseLeave={(event) => {
          event.stopPropagation();
          setHighlighted(false);
        }}
      >
        {children}
      </Box>
    </Bleed>
  );
};
export const Annotation = ({ children }: { children: ReactNode }) => (
  <Box
    display="flex"
    justifyContent="flexEnd"
    margin="xsmall"
    position="absolute"
    right={0}
    top={0}
  >
    <Text size="xsmall" tone="formAccent">
      <InlineCode>{children}</InlineCode>
    </Text>
  </Box>
);
